import Link from 'next/link';
import flags from 'emoji-flags';
import AuthorName from '../General/AuthorName';
import FutureImage from '../FutureImage';
import { INK, MUTED, PAPER_CARD } from './ui';

function countryEmoji(countryCode) {
  if (!countryCode) return null;
  const flag = flags.countryCode(countryCode.toUpperCase());
  return flag ? flag.emoji : null;
}

// "Curation desk" card showing real recently-featured community posts.
export default function FeaturedPostsStrip({ posts }) {
  const items = (posts || []).slice(0, 3);

  return (
    <div
      className={`${PAPER_CARD} tw-rounded-2xl tw-p-5 tw-shadow-[0_24px_50px_-24px_rgba(29,45,40,0.35)]`}
    >
      <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between">
        <span className="tw-font-mono tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.25em] tw-text-[#5F6F69] dark:tw-text-[#93A69E]">
          Curation desk · recently featured
        </span>
        <span className="tw-rounded-full tw-bg-amber-500/10 tw-px-2.5 tw-py-1 tw-font-mono tw-text-[10px] tw-font-semibold tw-tracking-widest tw-text-amber-700 dark:tw-text-amber-400">
          ⭐ LIVE
        </span>
      </div>
      <div className="tw-flex tw-flex-col tw-gap-3">
        {items.length > 0
          ? items.map(post => {
              const flag = countryEmoji(post.location?.countryCode);
              return (
                <Link
                  key={`${post.author.username}-${post.permlink}`}
                  href={`/@${post.author.username}/${post.permlink}`}
                  prefetch={false}
                  className="tw-group tw-flex tw-items-center tw-gap-4 tw-rounded-xl tw-border tw-border-solid tw-border-transparent tw-p-2 tw-no-underline tw-transition-colors hover:tw-border-[#E7E0CF] dark:hover:tw-border-[#26382F] hover:tw-bg-[#FAF8F1] dark:hover:tw-bg-[#1A2A24]"
                >
                  {post.thumb?.url && (
                    <FutureImage
                      src={post.thumb.url}
                      alt=""
                      width={96}
                      height={72}
                      placeholder={post.thumb.blur ? 'blur' : undefined}
                      blurDataURL={post.thumb.blur}
                      className="tw-h-[72px] tw-w-24 tw-shrink-0 tw-rounded-lg tw-object-cover"
                    />
                  )}
                  <div className="tw-min-w-0">
                    <p
                      className={`${INK} tw-m-0 tw-overflow-hidden tw-text-[15px] tw-font-semibold tw-leading-snug [-webkit-box-orient:vertical] [-webkit-line-clamp:2] [display:-webkit-box]`}
                    >
                      {post.title}
                    </p>
                    <p
                      className={`${MUTED} tw-m-0 tw-mt-1 tw-flex tw-items-center tw-gap-1.5 tw-text-xs`}
                    >
                      {flag && <span aria-hidden="true">{flag}</span>}
                      <AuthorName
                        author={post.author}
                        className="tw-truncate"
                      />
                    </p>
                  </div>
                </Link>
              );
            })
          : // Build-time data unavailable — keep the frame intentional.
            [0, 1, 2].map(i => (
              <div key={i} className="tw-flex tw-items-center tw-gap-4 tw-p-2">
                <div className="tw-h-[72px] tw-w-24 tw-shrink-0 tw-rounded-lg tw-bg-[#EDE7D8] dark:tw-bg-[#26382F]" />
                <div className="tw-flex-1">
                  <div className="tw-h-3.5 tw-w-4/5 tw-rounded tw-bg-[#EDE7D8] dark:tw-bg-[#26382F]" />
                  <div className="tw-mt-2 tw-h-3 tw-w-2/5 tw-rounded tw-bg-[#EDE7D8] dark:tw-bg-[#26382F]" />
                </div>
              </div>
            ))}
      </div>
      <Link
        href="/explore"
        prefetch={false}
        className="tw-mt-4 tw-block tw-text-center tw-text-sm tw-font-semibold tw-text-primary-700 dark:tw-text-primary-300 tw-no-underline hover:tw-underline"
      >
        Browse all featured stories →
      </Link>
    </div>
  );
}
